/// <amd-module name="Repos/Tfvc/Views/ShelvesetDetails/ShelvesetDiscussionThreadService" />
import { ArtifactDiscussionThreadService, IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { DiscussionThreadPermissions } from "Repos/Discussion/DiscussionThread.Types";
import { getArtifactUri } from "Repos/Tfvc/Common/Utils/Shelveset";
import { ITfvcChangeData, ITfvcChangeItem } from "Repos/Tfvc/Views/ChangeDetails/Contracts";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IShelvesetDetailsData } from "./Contracts";

export interface IShelvesetDiscussionThreadService extends IArtifactDiscussionThreadService {}

const dataProviderId = "ms.vss-code-web.tfvc-details-view-data-provider";

class ShelvesetDiscussionThreadService extends ArtifactDiscussionThreadService implements IShelvesetDiscussionThreadService {
    protected getArtifactUri(pageContext: IVssPageContext): string {
        const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        const changesData = contributionService.getData<ITfvcChangeData<ITfvcChangeItem>>(dataProviderId);
        const tfvcChangeDetails = changesData ? (changesData.tfvcChangeDetails as IShelvesetDetailsData) : undefined;

        // We encode shelveset name and owner using encodeURIComponent but since server encodes the artifact uri twice
        // when it validates it, we need to encode again
        return tfvcChangeDetails ? encodeURI(getArtifactUri(tfvcChangeDetails.shelvesetName, tfvcChangeDetails.owner)) : "";
    }
    protected getPermissions(): DiscussionThreadPermissions {
        // Any valid user can do all of these
        return DiscussionThreadPermissions.ChangeStatus | DiscussionThreadPermissions.LikeComment | DiscussionThreadPermissions.ManageComment;
    }
}

const serviceName = "IShelvesetDiscussionThreadService";
export function getDiscussionThreadService(pageContext: IVssPageContext): IShelvesetDiscussionThreadService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ShelvesetDiscussionThreadService });
